import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { FormWrapper } from '../Form';
import './AutoComplete.css';
/* global google */
const AutoComplete = props => {
  const { place, onChange, required } = props;
  return (
    <FormWrapper required={required} text="Wohnort" type="input">
      <div className="autoComplete">
        <PlacesAutocomplete
          inputProps={{ value: (place || ''), onChange: address => onChange(address), required }}
          options={{
            types: ['(regions)'],
            radius: 300000,
            location: new google.maps.LatLng(47.166168, 8.515495)
          }}
          classNames={{ autocompleteItemActive: 'autocompleteItemActive' }}
        />
      </div>
    </FormWrapper>
  );
};

export default AutoComplete;



// WEBPACK FOOTER //
// ./src/pages/Helpers/AutoComplete/index.js